import { IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { EditFeatureState } from "../editFeature.reducer";

export const saveGeoBordersPartialReducer: IPartialReducer<EditFeatureState> = (state, action) => {
    return {
        ...state,
        options: {
            ...state.options,
            geoBorders: action.geoBorders,
        },
    };
};
